export default async function main(imageUrl) {
  let response = await fetch(imageUrl, {
    method: "HEAD",
  });

  return response;
}

if (require.main) main(process.argv.slice(2)).catch(console.error);
